import { isMobileBreakpoint, mediaQueryLarge } from "@theme/utilities";

class ScrollingGallery extends HTMLElement {
  constructor() {
    super();
    this.isMobile = isMobileBreakpoint();
    this._io = null;
  }

  connectedCallback() {
    this.initAnimations();
    mediaQueryLarge.addEventListener("change", this.#onMediaQueryChange.bind(this));
  }

  disconnectedCallback() {
    this._io?.disconnect();
    mediaQueryLarge.removeEventListener("change", this.#onMediaQueryChange.bind(this));
  }

  /**
   * @param {MediaQueryListEvent} e
   */
  #onMediaQueryChange(e) {
    this.isMobile = !e.matches;
    this.reinitAnimations();
  }

  reinitAnimations() {
    this._io?.disconnect();
    this.initAnimations();
  }

  initAnimations() {
    const wrappers = this.querySelectorAll('.scrolling-gallery__image-wrapper');
    if (!wrappers.length) return;

    this._io?.disconnect();

    const isMobile = this.isMobile;
    const threshold = isMobile ? 0.2 : 0.5;
    const className = isMobile ? 'is-visible' : 'is-visible-desktop';

    this._io = new IntersectionObserver((entries, io) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add(className);
        io.unobserve(entry.target);
      }
    }, { threshold });

    wrappers.forEach(el => this._io?.observe(el));
  }
}

if (!customElements.get("scrolling-gallery")) {
  customElements.define("scrolling-gallery", ScrollingGallery);
}